import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface GetOCClaimInitialValuesRequestParams {
  carrierKey?: string | number;
}

interface OCClaimInitialValuesApi {
  fbOcKey: number;
  customerClaimNo: null;
  customerName: string;
  customerDisplayAddress: string;
  statusCode: 'O';
  reasonCode: string | null;
  ocTypeKey: number;
  overchargeSum: number;
  recoverySum: number;
  auditedBy: number;
  createdBy: number;
  submittedBy: string;
  preparedBy: string;
  carrierClaimNo: null;
  carrierKey: number;
  carrierName: string | null;
  carrierEmail: string | null;
  carrierDisplayAddress: string | null;
  fbAttach: string;
  bolAttach: string;
  invAttach: string;
  otherAttach: string;
  otherDesc: string | null;
  dateSubmitted: string | null;
  ammendmentDate: string | null;
  closedDate: string | null;
  checkNoFromCarrier: null;
  checkNoToCustomer: null;
  checkDateToCustomer: null;
  createdOn: string | null;
  modifiedOn: string | null;
  modifiedBy: number | null;
  currencyCode: string;
  uploadedFromExcel: null;
  claimItem: null;
  claimComment: null;
  claimSettlement: null;
}

export const getOverChargeClaimInitialValuesAPI = (params: GetOCClaimInitialValuesRequestParams) => {
  return axiosInstance.request({
    url: `${API.OVERCHARGE_CLAIM}/GetInitialClaimData`,
    method: 'get',
    params,
  });
};

export type OCClaimInitialValuesResponse = OCClaimInitialValuesApi;

export const fetchOCClaimInitialValues = async (
  params: GetOCClaimInitialValuesRequestParams,
): Promise<OCClaimInitialValuesResponse> => {
  const response: AxiosResponse<OCClaimInitialValuesResponse> = await getOverChargeClaimInitialValuesAPI(params);
  return response.data;
};
